.header-strip {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1.6rem;
  gap: 0.8rem;
  background: var(--color-surface-secondary);
  border: none;
}

.left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-texts-high-contrast);
  user-select: none;
  margin-inline-end: 0.8rem;
}

.count {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-texts-low-contrast);
  user-select: none;
}

.action {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 0 0 auto;
}
